export default __webpack_public_path__ + "static/media/hayq-min.98842887.png";